<div class="dialog-footer">
  <button class="btn btn-secondary" (click)='popupHelper.hidePopup()'>Abbrechen</button>
  <button class="btn btn-primary" (click)='saveClicked($event)'>Speichern</button>
</div>
